import React, { useEffect, useState } from "react";
import DialogBoxWithConfirmation from "../../util/DialogBoxWithConfirmation";
import { useTranslation } from "react-i18next";
import ConfigMarkerForm from "./ConfigMarkerForm";
import RessourceMarkerForm from "./RessourceMarkerForm";
import QuizMarkerForm from "./QuizMarkerForm";
const TouristicMarkerForm = (props) => {
  const { t } = useTranslation();
  const {
    marker,
    setMarkers,
    handleImageChange,
    handleVideoChange,
    handleAudioChange,
    handleIconChange,
    handleDeleteIcon,
    handleDeleteAllMedia,
    updateImageName,
    updateVideoName,
    updateAudioName,
    updateIconNameWithoutBorder,
    markerImage,
    markerAudio,
    markerVideo,
    markerIcon,
    projectDatas,
    setMarkerAudio,
    setMarkerImage,
    setMarkerVideo,
    setMarkerIcon,
    markerAccesValue,
    markerImageName,
    markerVideoName,
    markerAudioName,
    iconNameWithoutBorder,
    setMarkerImageName,
    setMarkerVideoName,
    setMarkerAudioName,
    showInputImage,
    setShowInputImage,
    showInputAudio,
    setShowInputAudio,
    showInputVideo,
    setShowInputVideo,
    showInputIcon,
    setShowInputIcon,
    setMarkerAccesValue,
    mainImage,
    imageIds,
    onChooseMainImage,
    onRemoveImage,
    onRemoveAllImages,
    triggerTypeRef,
    triggerDistance,
    setTriggerDistance,
    url,
    setUrl,
    showConfigPOI,
    showRessourcePOI,
    showQuizPOI,
    handleInputFocus,
    handleInputBlur,
    markerTitle,
    setMarkerTitle,
    markerDescription,
    setMarkerDescription,
    markerDistance,
    updateMarkerDistance,
    markerOpenQuestion,
    setMarkerOpenQuestion,
    markerQcmArray,
    setMarkerQcmArray,
    markerQcmImageArray,
    setMarkerQcmImageArray,
  } = props;
  // Constat f4 (revue finale du 01/10) : l'état triggerType vit ICI —
  // MarkerEditionForm ne le transmettait plus au ConfigMarkerForm (la
  // chaîne Trigger était cassée : setTriggerType undefined au changement,
  // crash du select). Réinitialisé depuis le marker à chaque monture ;
  // chaque changement met à jour le miroir ref que lit la sauvegarde.
  const [triggerType, setTriggerType] = useState(
    marker.triggerType ? marker.triggerType : ""
  );
  const changeTriggerType = (value) => {
    setTriggerType(value);
    if (triggerTypeRef) {
      triggerTypeRef.current = value;
    }
  };
  // Constat f7/f9 (revue finale du 01/10) : l'ancien useEffect qui
  // resynchronisait resourceArray (noms image/video/audio) a été SUPPRIMÉ
  // — resourceArray vit avec markerImageName dans MarkerEditionForm
  // (onRemoveAllImages y retire les noms d'image).

  /**
   * Permet de supprimer toutes les images
   * @param {event} e - clic sur le bouton
   */
  const handleDeleteAllImage = async (e) => {
    e.stopPropagation();
    const confirmDelete = await DialogBoxWithConfirmation({
      title: t("deleteImages"),
      text: t("deleteImagesText"),
      icon: "warning",
      cancelButtonText: t("no"),
      confirmButtonText: t("yes"),
    });
    // Confirmer la suppression
    if (confirmDelete && (await handleDeleteAllMedia?.("image"))) {
      // Constat f9 (revue finale du 01/10) : le repli local partiel est
      // SUPPRIMÉ — sans le callback parent dédié (qui vide aussi ids,
      // mainImage et mainResource), NE RIEN supprimer : un vidage partiel
      // local laisserait un état incohérent (identités/principale
      // orphelines).
      onRemoveAllImages?.();
    }
  };

  /**
   * Permet de supprimer toutes les vidéos
   * @param {event} e
   */

  const handleDeleteAllVideo = async (e) => {
    e.stopPropagation();
    const confirmDelete = await DialogBoxWithConfirmation({
      title: t("deleteVideos"),
      text: t("deleteVideosText"),
      icon: "warning",
      cancelButtonText: t("no"),
      confirmButtonText: t("yes"),
    });
    // Confirmer la suppression
    if (confirmDelete && (await handleDeleteAllMedia?.("video"))) {
      setMarkerVideo("");
      setMarkerVideoName("");
    }
  };

  /**
   * Permet de supprimer toutes les audios
   * @param {event} e
   */
  const handleDeleteAllAudio = async (e) => {
    e.stopPropagation();
    const confirmDelete = await DialogBoxWithConfirmation({
      title: t("deleteAudios"),
      text: t("deleteAudiosText"),
      icon: "warning",
      cancelButtonText: t("no"),
      confirmButtonText: t("yes"),
    });
    // Confirmer la suppression
    if (confirmDelete && (await handleDeleteAllMedia?.("audio"))) {
      setMarkerAudio("");
      setMarkerAudioName("");
    }
  };

  return (
    <>
      <div className="m-1">
        {showConfigPOI && (
          <ConfigMarkerForm
            marker={marker}
            markerIcon={markerIcon}
            markerAccesValue={markerAccesValue}
            markerAudio={markerAudio}
            markerVideo={markerVideo}
            projectDatas={projectDatas}
            setMarkerIcon={setMarkerIcon}
            setMarkerAccesValue={setMarkerAccesValue}
            handleIconChange={handleIconChange}
            handleDeleteIcon={handleDeleteIcon}
            iconNameWithoutBorder={iconNameWithoutBorder}
            updateIconNameWithoutBorder={updateIconNameWithoutBorder}
            triggerType={triggerType}
            setTriggerType={changeTriggerType}
            triggerDistance={triggerDistance}
            setTriggerDistance={setTriggerDistance}
            showInputIcon={showInputIcon}
            setShowInputIcon={setShowInputIcon}
            markerDistance={markerDistance}
            updateMarkerDistance={updateMarkerDistance}
          />
        )}
        {showRessourcePOI && (
          <RessourceMarkerForm
            marker={marker}
            setMarkers={setMarkers}
            showInputAudio={showInputAudio}
            showInputImage={showInputImage}
            showInputVideo={showInputVideo}
            setShowInputAudio={setShowInputAudio}
            setShowInputImage={setShowInputImage}
            setShowInputVideo={setShowInputVideo}
            markerImage={markerImage}
            markerVideo={markerVideo}
            markerAudio={markerAudio}
            markerImageName={markerImageName}
            markerVideoName={markerVideoName}
            markerAudioName={markerAudioName}
            setMarkerImage={setMarkerImage}
            setMarkerVideo={setMarkerVideo}
            setMarkerAudio={setMarkerAudio}
            setMarkerImageName={setMarkerImageName}
            setMarkerVideoName={setMarkerVideoName}
            setMarkerAudioName={setMarkerAudioName}
            mainImage={mainImage}
            imageIds={imageIds}
            onChooseMainImage={onChooseMainImage}
            onRemoveImage={onRemoveImage}
            handleAudioChange={handleAudioChange}
            handleVideoChange={handleVideoChange}
            handleImageChange={handleImageChange}
            handleDeleteAllAudio={handleDeleteAllAudio}
            handleDeleteAllImage={handleDeleteAllImage}
            handleDeleteAllVideo={handleDeleteAllVideo}
            updateAudioName={updateAudioName}
            updateImageName={updateImageName}
            updateVideoName={updateVideoName}
            handleInputFocus={handleInputFocus}
            handleInputBlur={handleInputBlur}
            markerTitle={markerTitle}
            setMarkerTitle={setMarkerTitle}
            markerDescription={markerDescription}
            setMarkerDescription={setMarkerDescription}
            url={url}
            setUrl={setUrl}
          />
        )}
        {showQuizPOI && (
          <QuizMarkerForm
            marker={marker}
            markerOpenQuestion={markerOpenQuestion}
            setMarkerOpenQuestion={setMarkerOpenQuestion}
            markerQcmArray={markerQcmArray}
            setMarkerQcmArray={setMarkerQcmArray}
            handleInputFocus={handleInputFocus}
            handleInputBlur={handleInputBlur}
            markerQcmImageArray={markerQcmImageArray}
            setMarkerQcmImageArray={setMarkerQcmImageArray}
          />
        )}
      </div>
    </>
  );
};

export default TouristicMarkerForm;
